import { render } from "./ProjectListWorkSpace.vue?vue&type=template&id=67091aa8"
import script from "./ProjectListWorkSpace.vue?vue&type=script&lang=js"
export * from "./ProjectListWorkSpace.vue?vue&type=script&lang=js"

import "./ProjectListWorkSpace.vue?vue&type=style&index=0&id=67091aa8&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__